import React from "react";

/**
 * Step indicator pill bar — shows "Step N of 6" plus a thin progress strip.
 * data-testid="plan-step-indicator", with aria-label "Step N of 6".
 */
export default function StepIndicator({ step, total = 6 }) {
  const pct = Math.max(0, Math.min(100, (step / total) * 100));
  return (
    <div
      data-testid="plan-step-indicator"
      aria-label={`Step ${step} of ${total}`}
      className="flex items-center gap-3"
    >
      <span className="text-[10px] uppercase tracking-[0.3em] text-[#1A1A1A]/60 sm:text-xs">
        Step <span className="text-[#1A1A1A]">{step}</span>{" "}
        <span className="text-[#1A1A1A]/40">of {total}</span>
      </span>
      <div className="relative h-[2px] w-32 overflow-hidden rounded-full bg-[#EAE3D2] sm:w-48">
        <div
          className="absolute inset-y-0 left-0 bg-[#C8A24B] transition-[width] duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
